import React, { useState, useEffect } from 'react'

import Navbar from '../../Components/Navbar/Navbar'
import toast from 'react-hot-toast';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { 
    Layout,
    Col, 
    Row,
    Button,
    // Dropdown, 
    Space,
    Modal,
    Form,
    Input,
    DatePicker,
    Table,
} from 'antd';
import { 
  // ExclamationCircleFilled, 
  ProductOutlined 
} from '@ant-design/icons';
import { 
  // MoreVert, 
  // GroupAdd 
} from '@mui/icons-material';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { usePostRequest } from '../../hooks/usePostRequest'
import TextArea from 'antd/es/input/TextArea';
import { formatDate } from '../../Utils/Common';
import { useNavigate } from "react-router-dom"

const { RangePicker } = DatePicker;
const { Item, List } = Form;
const { Search } = Input;

const FunGolf = () => {
  const navigate = useNavigate()
  const [addVisible, setAddVisible] = useState(false);
  // const [editVisible, setEditVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  // const [invitationalId, setInvitationalId] = useState('');
  const [pageSize, setPageSize] = useState('');
  // const [invitationalDetails, setInvitationalDetails] = useState({
  //     name: '',
  //     date:'',
  //     remarks:'',
  // });
  const [filterConfig, setFilterConfig] = useState({
    tournament_id: '',
    employee_id: '',
    page: 1,
    game_type: 'Fun Golf'
  })
  const [invitationalData, setInvitationalData] = useState([])

  const [addForm] = Form.useForm();
  const [editForm] = Form.useForm();
  const { callPost, loading } = usePostRequest(()=>{
    fetchInvitationalData()
    addForm.resetFields();
    editForm.resetFields();
    setAddVisible(false);
    // setEditVisible(false);
  });
  const customSpinner = <ProductOutlined style={{ fontSize: 24 }} spin />;

  const columns = [
    {
      title: 'TOURNAMENTS',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'DATES',
      dataIndex: 'date_range',
      key: 'date_range',
    },
    {
      title: 'REMARKS',
      dataIndex: 'remarks',
      key: 'remarks',
    },
  ];

  async function fetchInvitationalData  () {
    setIsLoading(true)
    const response = await UseGetRequest("tournaments/get", filterConfig);
    if (response?.data) {
      const data = response?.data?.data?.map((data) => ({
        id: data.id,
        name: data.name,
        date_from: data.date_from,
        date_to: data.date_to,
        date_range: formatDate(data.date_from) + " - " + formatDate(data.date_to),
        remarks: data.remarks,
        game_type: data.game_type,
        divisions: data.divisions,
      }))
      setInvitationalData(data);
      setPageSize(response?.data?.size)
    } else {
        setInvitationalData([])
    }

    setIsLoading(false);
  }

  const handleAddOk = () => {
    addForm.validateFields().then(values => {
        const data = {
            name: values.name,
            remarks: values.remarks || '',
            date_from: values.date[0].format('YYYY-MM-DD'),
            date_to: values.date[1].format('YYYY-MM-DD'),
            division_names: values?.divisions?.map((item)=>item.division_names),
            game_type: "Fun Golf"
        }
        var finalValues = Object.entries(data).map(([key, value]) => ({
            key,
            value,
        }));
        callPost(
            "tournaments/add", 
            finalValues,
            true
        );
    }).catch(errorInfo => {
      toast.error('Validation Failed:', errorInfo);
    });
  };
  


  const showAddModal = () => {
    setAddVisible(true);
  };

  

  const handleAddCancel = () => {
    addForm.resetFields();
    setAddVisible(false);
  };

  
  const validateSpaces = (_, value) => {
    if (value && value.trim().length === 0) {
      return Promise.reject('Please enter a value other than spaces');
    } else {
      return Promise.resolve();
    }
  };

  const onSearch = (e) => {
    setFilterConfig((prev) => (
      {
        ...prev,
        search: e.target.value || ''
      }
    ));
  };  

  const handleTableChange = (pagination) => {
    setFilterConfig((prev) => ({
      ...prev,
      page: parseInt(pagination.current),
      // total_records_per_page: pagination.pageSize,
    }));
  };

  useEffect(() => {
    fetchInvitationalData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterConfig]);



  return (
    <Layout className='page'>
        <Navbar navKey={'fun_golf_nav'}/>
        <Layout className='content-container overflow-y'>
          <Row className='custom-padding responsive-tab-inline'>
            <Col span={15} className='header-container'>
              FUN GOLF
            </Col>
            <Col span={9} className='mt-2 responsive-tab-width' align='end'>
              <Space className='responsive-inline'> 
                <Search
                  placeholder="Search..."
                  size='medium'
                  onChange={(e)=>onSearch(e)}
                  className='responsive-header-input'
                />           
                <Button 
                  className='button-color responsive-header-btn' 
                  onClick={showAddModal} 
                  type="primary"
                >
                  + Add Tournament
                </Button>
              </Space>
            </Col>
          </Row>
          <Row className='page-content'>
            <Col span={24} className='responsive-overflow-auto'>
            <Table 
              columns={columns} 
              dataSource={invitationalData} 
              loading={{
                indicator: customSpinner,
                spinning: isLoading,
              }}
              pagination={{
                defaultPageSize: 10,
                total: pageSize,
                current: filterConfig?.page,
                pageSize: filterConfig?.total_records_per_page,
              }}
              onChange={handleTableChange}
              onRow={(record, rowIndex) => {
                return {
                  className: 'cursor',
                  onClick: () => navigate('/fun-golf/player/' + record.id),
                };
              }}
            />
            </Col>
          </Row>
        </Layout>
        <Modal
          title="Add Tournament"
          confirmLoading={loading}
          open={addVisible}
          onOk={handleAddOk}
          onCancel={handleAddCancel}
          okText="Submit"
          maskClosable={false}
        >
          <Form 
            form={addForm} 
            layout="vertical"
            initialValues={{
              divisions: [{}]  // This initializes the `player` field with one empty object, creating one default row.
            }}
          >
            <Item
                label="Name"
                name="name"
                rules={[
                { required: true, message: 'Please enter your Name!' },
                { validator: validateSpaces }
                ]}
                
            >
                <Input />
            </Item>
            <Item
                label="Date"
                name="date"
                rules={[
                    { 
                        required: true, message: 'Please enter your Date Range!' 
                    },
                ]}
            >
                <RangePicker  
                    style={{width:'100%'}}
                    placeholder={['Date From', 'Date To']}
                    format={'YYYY/MM/DD'}
                />
            </Item>
            <Item
                label="Remarks"
                name="remarks"
            >
            <TextArea rows={3}/>
            </Item>
            <List label="Division" name="divisions">
                {(fields, { add, remove }) => (
                    <>
                        {fields.map(({ key, name, fieldKey, ...restField }) => (
                            <Space key={key} style={{ display: 'flex', marginBottom: 8,  width: '150%'}} align="baseline">
                                <Item
                                    {...restField}
                                    name={[name, 'division_names']}
                                    fieldKey={[fieldKey, 'division_names']}
                                    rules={[{ required: true, message: 'Please input division!' }]}
                                >
                                    <Input 
                                        placeholder="Enter Division" 
                                    />
                                    
                                </Item>
                                {fields.length > 1 ? (
                                    <MinusCircleOutlined onClick={() => remove(name)} />
                                ) : null}
                            </Space>
                        ))}
                        <Item>
                            <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                                Add Division
                            </Button>
                        </Item>
                    </>
                )}
            </List>
          </Form>
        </Modal>
    </Layout>
  )
}

export default FunGolf